import React from "react";
import { Link } from "react-router-dom";
import { Hammer, Sparkles, ArrowRight } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

export const ComingSoon = ({ title, blurb, testId }) => {
  const { locale } = useLang();
  const isFr = locale === "fr";
  return (
    <main className="relative max-w-5xl mx-auto px-6 lg:px-10 pt-20 pb-24" data-testid={testId || "coming-soon"}>
      <p className="label-overline mb-4 text-[#D4AF37]">
        {isFr ? "Section en cours de création" : "Section under construction"}
      </p>
      <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-amber-glow leading-tight mb-8 tracking-tight">
        {title}
      </h1>

      <div className="rounded-3xl border border-[#D4AF37]/30 bg-gradient-to-br from-[#D4AF37]/10 via-[#0A1128]/40 to-transparent backdrop-blur-sm p-8 lg:p-12 relative overflow-hidden">
        <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-[#D4AF37]/10 blur-3xl pointer-events-none" />
        <div className="relative flex flex-col items-start gap-5">
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#D4AF37]/40 bg-[#D4AF37]/15 text-[#D4AF37] text-xs font-mono-tech uppercase tracking-[0.25em]">
            <Hammer size={12} /> {isFr ? "Prochainement" : "Coming soon"}
          </span>
          <h2 className="font-display text-2xl md:text-3xl text-cyan-glow leading-snug">
            {isFr
              ? "Cette section est en cours de création."
              : "This section is under construction."}
          </h2>
          <p className="text-slate-300 leading-relaxed text-base max-w-2xl">
            {blurb || (isFr
              ? "À très vite pour découvrir mes recommandations et mes produits."
              : "See you very soon to discover my recommendations and products.")}
          </p>
          <div className="flex flex-wrap gap-3 pt-3">
            <Link to="/" className="btn-gold" data-testid={`${testId}-cta-home`}>
              <Sparkles size={14} /> {isFr ? "Retour à l'accueil" : "Back to home"}
            </Link>
            <Link to="/contact" className="btn-primary" data-testid={`${testId}-cta-contact`}>
              {isFr ? "Me contacter" : "Contact me"} <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </div>
    </main>
  );
};
